<script setup lang="ts">

import GFBSShipMaintenance
  from '@/components/Sections/Government/Finances/BalanceSheetDetails/ShipMaintenance/GFBSShipMaintenance.vue'
</script>

<template>
  <div>
    <GFBSShipMaintenance/>
  </div>
</template>

<style scoped lang="scss">

</style>